module.exports = __webpack_public_path__ + "img/nf.6860552f.svg";